import { SelectInputWithMenu as VFSelectMenu } from "@vfuk/core-select-input-with-menu/dist/SelectInputWithMenu";
import { SelectInputWithMenuProps as VFSelectMenuProps } from "@vfuk/core-select-input-with-menu/dist/SelectInputWithMenu.types";
import { ReactNode, forwardRef, useState } from "react";
import FloatingLabelBase from "../FloatingLabelBase/FloatingLabelBase";
import "./FloatingLabelSelectMenu.scss";

type TextInputProps = {
  label: string;
  error?: string;
  tooltipError?: ReactNode;
  spaceForError?: boolean;
} & VFSelectMenuProps;

export const FloatingLabelSelectMenu = forwardRef<VFSelectMenu, TextInputProps>(
  ({ label, error, ...inputProps }: TextInputProps, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
      <FloatingLabelBase
        forceFloat={!!inputProps.value}
        onShowPassword={() => setShowPassword(!showPassword)}
        showPassword={showPassword}
        label={label}
        error={error}
        {...inputProps}
      >
        <VFSelectMenu ref={ref} {...inputProps} placeholder="" />
      </FloatingLabelBase>
    );
  }
);

FloatingLabelSelectMenu.displayName = "FloatingLabelInput";
